"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSlidesPerView = void 0;
var _constants = require("../constants");
const getSlidesPerView = slider => {
  if (typeof slider?.slides === 'object') {
    const value = typeof slider.slides?.perView === 'function' ? slider.slides.perView() : slider.slides?.perView;
    return typeof value === 'number' ? value : _constants.SLIDES_PER_VIEW_DEFAULT_VALUE;
  }
  return _constants.SLIDES_PER_VIEW_DEFAULT_VALUE;
};
exports.getSlidesPerView = getSlidesPerView;
